import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InputTextModule} from 'primeng/inputtext';
import {SidebarModule} from 'primeng/sidebar';
import {BadgeModule} from 'primeng/badge';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TooltipModule} from 'primeng/tooltip';
import {RippleModule} from 'primeng/ripple';
import {AppConfigModule} from './config/app.config.module';
import {AppLayoutComponent} from './app.layout.component';
import {AppBreadcrumbComponent} from './app.breadcrumb.component';
import {AppSidebarComponent} from './app.sidebar.component';
import {AppTopbarComponent} from './app.topbar.component';
import {AppProfileSidebarComponent} from './app.profilesidebar.component';
import {AppMenuComponent} from './app.menu.component';
import {AppMenuitemComponent} from './app.menuitem.component';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {AvatarModule} from 'primeng/avatar';
import {SharedModule} from '../components/shared/shared.module';
import {DialogModule} from 'primeng/dialog';
import {ModalsModule} from '../components/modals/modals.module';
import {MenuModule} from 'primeng/menu';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {LayoutShellComponent} from './service/layout-shell.component';
import {CommonModule} from '@angular/common';
import { WaitlistBannerComponent } from '../components/waitlist-banner/waitlist-banner.component';

@NgModule({
    declarations: [
        AppLayoutComponent,
        AppBreadcrumbComponent,
        AppSidebarComponent,
        AppTopbarComponent,
        AppProfileSidebarComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        LayoutShellComponent
    ],
    exports: [
        LayoutShellComponent,
        AppTopbarComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        InputTextModule,
        SidebarModule,
        BadgeModule,
        RadioButtonModule,
        InputSwitchModule,
        ButtonModule,
        TooltipModule,
        RippleModule,
        RouterModule,
        AppConfigModule,
        AvatarModule,
        DialogModule,
        SharedModule,
        ModalsModule,
        MenuModule,
        OverlayPanelModule,
        CommonModule,
        WaitlistBannerComponent
    ]
})
export class AppLayoutModule { }
